import React, { useState } from "react";
import "./Styles/UserSection.scss";
import LogoutBtn from "./Functions/Logout";
import UpdateProfile from "./Functions/UpdateProfile";
import UploadCSV from "./Functions/UploadCSV";
import AvatarSection from "./AvatarSection";
import AddCertificateType from "./AdminDashboard/AddCertificateType";
import { mainBaseUrl } from "../App";
import { useHistory } from "react-router";
import Leadbutton from "./AddLead/Lead.button";
import AddTemplate from "./AddCertificateTemplate/AddTemplate.button";

const UserSection = ({ profile, profileInfo, admin, getInfo }) => {
  const imgUrl = `${mainBaseUrl}/users/${profile["_id"]}/avatar`;

  const history = useHistory();
  const roteChange = () => {
    history.push({
      pathname: "/about",
    });
  };
  return (
    <div className="user-section">
      <div className="main-container">
        <AvatarSection imgUrl={imgUrl} />
        <p className="user-name">{profile["name"]}</p>
        <p className="user-email">{profile["email"]}</p>
        <UpdateProfile
          name={profile["name"]}
          mobile={profile["mobile"]}
          profileInfo={profileInfo}
        />
        <UploadCSV getInfo={getInfo} />

        {admin ? <AddTemplate /> : ""}
        {admin ? <AddCertificateType /> : ""}
        {admin ? <Leadbutton /> : ""}

        <button
          onClick={roteChange}
          style={{
            backgroundColor: "transparent",
            color: "black",
            border: "2px solid black",
          }}
        >
          About
        </button>
      </div>
      <LogoutBtn />
    </div>
  );
};

export default UserSection;
